import helpers from './helpers';

import 'alpine-magic-helpers'
import 'alpinejs';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
require('./polyfills');
require('./accessibility');

window.helpers = helpers;

window.AlpineComponents = {
    // Larger than average Alpine components will be attached to this
    // object from within the site's template. DO NOT DELETE PLEASE!
};

const lineClamp = require('line-clamp');

const lineClampElements = document.querySelectorAll('.line-clamp');

for (let i = 0; i < lineClampElements.length; i++) {
    if (lineClampElements[i].className.endsWith('line-clamp line-clamp--4')) {
        lineClamp(lineClampElements[i], 4);
    } else if (lineClampElements[i].className.endsWith('line-clamp line-clamp--5')) {
        lineClamp(lineClampElements[i], 5);
    }
}

/**
 * Set IntersectionObservers
 * @type {Array}
 */
let observers = [];

function setIntersectionObservers() {
    let triggerableItems = document.querySelectorAll(".triggerable");

    // Options for the observers

    let observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: [0,0.25,0.5,0.75,1]
    };

    // Add each box, creating a new observer for each

    for (let i = 0; i < triggerableItems.length; i++) {

        observers[i] = new IntersectionObserver(intersectionCallback, observerOptions);
        observers[i].observe(triggerableItems[i]);
    }
}

function intersectionCallback(entries) {
    entries.forEach((entry) => {
        if (entry.intersectionRatio > 0.5) {
            entry.target.classList.add("triggerable--triggered");
            let anims = entry.target.querySelectorAll(".has-animation");
            if(anims.length > 0) {
                for(let i = 0; i < anims.length; i++) {
                    anims[i].classList.add("has-animation--running");
                }
            }
        }
    });
}

setIntersectionObservers();

/**
 * Scroll triggers page 2
 * TODO: OPTIMISE ALL OF THIS!
 */
/**
 * Generally hide the navigation when not needed on mobile
 */
ScrollTrigger.matchMedia({

    "(min-width: 1024px)": function() {
        ScrollTrigger.create({
            trigger: ".strategies__grid",
            start: 'top bottom',
            end: 'bottom top',
            toggleClass: {targets: ".strategies", className: "strategies--in-view"},
        });
    },

    "(max-width: 1023px)": function() {
        ScrollTrigger.create({
            trigger: ".strategies__grid",
            start: '-=70 top',
            end: 'bottom +=70',
            toggleClass: {targets: ".strategies", className: "strategies--in-view"},
        });
    },

    // Prevent the header to appear once the chapters are shown
    "all": function() {
        ScrollTrigger.create({
            trigger: ".strategies__grid",
            start: '-=70 top',
            end: 'bottom bottom',
            onEnter: function() { document.querySelector(".header").dataset.hidden = "true" },
            onEnterBack: function() { document.querySelector(".header").dataset.hidden = "true" },
            onLeaveBack: function() { document.querySelector(".header").removeAttribute("data-hidden") },
            onLeave: function() { document.querySelector(".header").removeAttribute("data-hidden") },
        });
    }
});

/**
 * Create scrollTriggers for each SVG
 */

scrollTrigger(1);
scrollTrigger(2);
scrollTrigger(3);
scrollTrigger(4);
scrollTrigger(5);
scrollTrigger(6);
scrollTrigger(7);
scrollTrigger(8);

function scrollTrigger(i) {
    if (document.querySelector("#strategy" + i + "_progress") === null) {
        return;
    }

    ScrollTrigger.matchMedia({

        "(min-width: 1024px)": function () {

            ScrollTrigger.create({
                trigger: "#strategy" + i + " ~ .strategy",
                start: 'top top',
                end: 'bottom top',
                toggleClass: {targets: "#strategyItem" + i, className: "strategies__toc-item--active"},
            });

            gsap.fromTo("#strategy" + i + "_progress", {
                attr: {value: 0},
            }, {
                scrollTrigger: {
                    trigger: "#strategy" + i + " ~ .strategy",
                    scrub: true,
                    start: 'top top',
                    end: 'bottom top',
                },
                attr: {value: 100},
                ease: "none"
            });
        },

        "(max-width: 1023px)": function () {

            ScrollTrigger.create({
                trigger: "#strategy" + i + " ~ .strategy",
                start: '-=70 top',
                end: 'bottom +=70',
                toggleClass: {targets: "#strategyItem" + i, className: "strategies__toc-item--active"},
            });

            gsap.fromTo("#strategy" + i + "_progress", {
                attr: {value: 0},
            }, {
                scrollTrigger: {
                    trigger: "#strategy" + i + " ~ .strategy",
                    scrub: true,
                    start: '-=70 top',
                    end: 'bottom +=70',
                },
                attr: {value: 100},
                ease: "none"
            });
        }
    });
}

gsap.utils.toArray(".strategies__toc a").forEach(function(a) {
    a.addEventListener("click", function(e) {
        e.preventDefault();
        history.pushState({}, '', '/oplossingen/' + e.target.getAttribute("data-slug"))
        gsap.to(window, {
            scrollTo: {
                y: e.target.getAttribute("href"),
                offsetY: -1, // make the damn thing triggered already...
                autoKill: false
            },
            ease: "power4.inOut",
            delay: 0,
        });
    });
});

if (document.getElementById("aWhitePath") !== null) {
    aPathDraw();
}

/**
 * Draw paths between the svgs
 */
pathDraw(1);
pathDraw(2);
pathDraw(3);
pathDraw(4);
pathDraw(5);
pathDraw(7);

function pathDraw(i) {

    ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {

            // If the index is 4, then there are two paths to draw
            if(i === 4) {
                const patha = document.getElementById("whitePath" + i + "a");
                const pathb = document.getElementById("whitePath" + i + "b");

                if(!patha || !pathb) {
                    return;
                }

                const pathaLength = patha.getTotalLength();
                const pathbLength = pathb.getTotalLength();
                patha.style.strokeDasharray = pathaLength + "px";
                pathb.style.strokeDasharray = pathbLength + "px";

                ScrollTrigger.create({
                    trigger: "#homeSolution" + i,
                    start: 'top 25%',
                    end: 'bottom 50%',
                });

                gsap.fromTo("#whitePath" + i + 'a', {
                    strokeDashoffset: pathaLength * 2 + "px",
                }, {
                    scrollTrigger: {
                        trigger: "#homeSolution" + i,
                        scrub: true,
                        start: 'top 25%',
                        end: 'bottom 50%',
                    },
                    strokeDashoffset: pathaLength + "px",
                    ease: "none"
                });

                gsap.fromTo("#whitePath" + i + 'b', {
                    strokeDashoffset: pathbLength * 2 + "px",
                }, {
                    scrollTrigger: {
                        trigger: "#homeSolution" + i,
                        scrub: true,
                        start: 'top 25%',
                        end: 'bottom 50%',
                    },
                    strokeDashoffset: pathbLength + "px",
                    ease: "none"
                });
            }
            // All other lines are just 1 path
            else {
                const range = (i === 5) ? ['-25%','25%'] : ['25%','50%'];
                const path = document.getElementById("whitePath" + i);

                if(!path) {
                    return;
                }

                const pathLength = path.getTotalLength();
                path.style.strokeDasharray = pathLength + "px";

                ScrollTrigger.create({
                    trigger: "#homeSolution" + i,
                    start: 'top ' + range[0],
                    end: 'bottom ' + range[1],
                });

                gsap.fromTo("#whitePath" + i, {
                    strokeDashoffset: pathLength * 2 + "px",
                }, {
                    scrollTrigger: {
                        trigger: "#homeSolution" + i,
                        scrub: true,
                        start: 'top ' + range[0],
                        end: 'bottom ' + range[1],
                    },
                    strokeDashoffset: pathLength + "px",
                    ease: "none"
                });
            }
        }
    });
}
